import AmplifyClient from './js/amplify-client';

export { AmplifyClient };
